export default __webpack_public_path__ + "static/media/arrow_down_black.c8dca2c8.svg";